import Cookies from 'js-cookie';

const className = 'is-hidden';

let cookieOptions = {
	sameSite: 'strict',
};

export function init() {
	let elements = Array.from(document.querySelectorAll('.js-alert'));

	elements.forEach(element => createAlert(element));
}

function createAlert(element) {
	let cookieName = element.dataset.id;
	let cookieExpiry = toDate(element.dataset.expiry);

	let controls = Array.from(element.querySelectorAll('.js-alert-dismiss'));
	controls.forEach(elem => elem.addEventListener('click', e => onClick(e)));

	if (cookieExpiry) {
		cookieOptions.expires = cookieExpiry;
	}

	function onClick() {
		element.classList.add(className);
		Cookies.set(cookieName, 'true', cookieOptions);
	}
}

function toDate(value) {
	let date = new Date(value);
	let isValid = date instanceof Date && !isNaN(date);

	if (!isValid) {
		return false;
	}

	return date;
}
